import { AuthProvider } from './../providers/auth/auth';
import { TasksPage } from './../pages/tasks/tasks';
import { InstallerTasksPage } from './../pages/installer-tasks/installer-tasks';
import { Component, ViewChild } from '@angular/core';
import { Nav, Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { AppVersion } from '@ionic-native/app-version';

import { LoginPage } from '../pages/login/login';
import { SupportPage } from '../pages/support/support';
import { ProfilePage } from '../pages/profile/profile';
import { ENV } from '../environments/environment';
import { TasksCompletePage } from '../pages/tasks-complete/tasks-complete';
import { UtilsProvider } from '../providers/utils/utils';
import { MaintenancePage } from '../pages/maintenance/maintenance';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage: any = LoginPage;

  allPages: Array<{ title: string; component: any }> = [
    { title: 'Schedule Tasks', component: TasksPage },
    { title: 'My Tasks', component: InstallerTasksPage },
    { title: 'Completed Tasks', component: TasksCompletePage },
    { title: 'Support', component: SupportPage },
    { title: 'Profile', component: ProfilePage },
    { title: 'Clear Cache', component: LoginPage },
    { title: 'Logout', component: LoginPage }
  ];
  pages: Array<{ title: string; component: any }> = [...this.allPages];
  user: any; // should be User
  appversionStr: string = '0.0.0';
  apiUri: string;
  public maintenanceMessage: string;

  constructor(
    public platform: Platform,
    public statusBar: StatusBar,
    public splashScreen: SplashScreen,
    private authProvider: AuthProvider,
    private appVersion: AppVersion,
    private utilsProvider: UtilsProvider
  ) {
    this.initializeApp();

    this.authProvider.userSubject.subscribe(
      user => {
        this.refresh(user);
      },
      e => {
        console.log(e);
        this.nav.setRoot(LoginPage);
        this.authProvider.logoutUser();
      }
    );

    this.apiUri = ENV.base;
  }

  hideSchedulePage(){
    if(this.authProvider.userData.jwtData){
      this.pages = this.pages.filter(page => {
        return page.title !== 'Schedule Tasks'
      })
    }
  }
  hideTasksPage(){
    if(this.authProvider.userData.jwtData){
      this.pages = this.pages.filter(page => {
        return page.title !== 'My Tasks'
      })
    }
  }

  refresh(user){
    this.pages = [...this.allPages]
    this.user = user;
    if(!this.authProvider.userData.isSchedular) {
      this.hideSchedulePage();
    }
    if(!this.authProvider.userData.isInstaller) {
      this.hideTasksPage();
    }
  }

  menuOpen(){
    this.refresh(this.authProvider.userData.data);
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
      this.maintenanceModeCheck()
      try {
        this.appVersion
          .getVersionNumber()
          .then(version => {
            this.appversionStr = version;
          })
          .catch(e => {
            // Cant get app version so is PWA
            this.utilsProvider.getMetadata().subscribe(ret => {
              this.appversionStr = ret && ret.version ? ret.version : "0.0.0"
            });
          });
      } catch (e) {}
    });
  }

  clearCache() {
    localStorage.clear();
    sessionStorage.clear();

    navigator.serviceWorker.getRegistrations().then(registrations => {
      for (let registration of registrations) {
        registration.unregister();
      }
    }).then(() => {
      localStorage.removeItem('app-version')
      window.location.reload();
    }).catch(err => {
      alert("App Service Worker Error" + JSON.stringify(err));
      localStorage.removeItem('app-version')
      window.location.reload();
    });
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    if (page.title == 'Logout') {
      //this.nav.setRoot(page.component);
      this.authProvider.logoutUser().subscribe(data => {
        this.nav.setRoot(page.component);
      });
    } else if (page.title == 'Clear Cache') {
      this.clearCache();
    } else {
      this.nav.setRoot(page.component, {uid: this.user?.uid});
    }
  }

  maintenanceModeCheck(){
    if(this.user)
    this.utilsProvider.checkMaintenanceMode().subscribe(res => {
      this.handleMainenanceResponse(res)
    })

    setInterval(() => {
      if(this.user)
      this.utilsProvider.checkMaintenanceMode().subscribe(res => {
        this.handleMainenanceResponse(res)
      })
    },1000 * 60)
  }

  handleMainenanceResponse(res){
    if(res && res.message){
      this.maintenanceMessage = res.message;
      sessionStorage.setItem('maintenanceMessage', res.message);
      const activePage = this.nav.getActive().name;
      if(activePage !== 'MaintenancePage') this.nav.push(MaintenancePage);
    } else {
      this.maintenanceMessage = null;
      sessionStorage.removeItem('maintenanceMessage');
      const activePage = this.nav.getActive().name;
      if(activePage === 'MaintenancePage') this.nav.push(LoginPage);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts